import { types } from "../action-types";

const initialState = {
  loading: false,
  views: [],
  error: false,
};

const getViewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_VIEWS_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_VIEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        views: action.payload.viewerProfile,
        error: false,
      };
    case types.GET_VIEWS_FAILURE:

      return {
        ...state,
        loading: false,
        views: [],
        error: true,
      };
    default:
      return state;
  }
};

export default getViewsReducer;
